var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvoiceActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.75 6.03998L27.5 3.78998L25.25 6.03998L23 3.78998L20.75 6.03998L18.5 3.78998L16.25 6.03998L14 3.78998L11.75 6.03998L9.5 3.78998L7.25 6.03998L5 3.78998V33.79L7.25 31.54L9.5 33.79L11.75 31.54L14 33.79L16.25 31.54L18.5 33.79L20.75 31.54L23 33.79L25.25 31.54L27.5 33.79L29.75 31.54L32 33.79V3.78998L29.75 6.03998ZM29 29.29H8V8.28998H29V29.29ZM9.5 23.29H27.5V26.29H9.5M9.5 17.29H27.5V20.29H9.5M9.5 11.29H27.5V14.29H9.5V11.29Z",
    fill: "#075E5B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceActive);
export default __webpack_public_path__ + "static/media/InvoiceActive.255042b03e94812c56280b93eedfc9b4.svg";
export { ForwardRef as ReactComponent };